<svelte:options runes={true} />
<script lang="ts">let { text, value = null, type = 'secondary', disabled = false, onclick: onclickProp = undefined, children } = $props();
function handleClick() {
    onclickProp === null || onclickProp === void 0 ? void 0 : onclickProp(value);
}
export {};
</script>

<button
  onclick={handleClick}
  {disabled}
  class="svelte-button"
  class:secondary={type === "secondary"}
  class:primary={type === "primary"}>{text}{#if children}{@render children()}{/if}</button
>

<style>
  .svelte-button {
    padding: 10px 20px;

    min-width: 210px;
    height: 60px;

    border-radius: 41px;

    border: none;

    font-size: 18px;
    line-height: 40px;

    text-align: center;

    cursor: pointer;
  }

  .svelte-button.secondary:active,
  .svelte-button.primary:active {
    color: #ffffff;
    background: #8d5fff;
  }  
  
  .svelte-button.secondary:hover,
  .svelte-button.primary:hover {
    color: #ffffff;
    background: #8d5fff;
    transition: .3s ease;
  }

  .primary {
    color: #ffffff;
    background: #8d5fff;
  }

  .secondary {
    color: #8d5fff;
    background: #ffffff;
  }</style>
